import React from 'react';
import './Assets.css';

function AssetsEn() {
  return (
    <section 
      className="assets" 
      id="assets"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets-hero-bg.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#1a1a1a'
      }}
    >
      <div className="assets-overlay"></div>
      <div className="container">
        <div className="assets-content">
          <div className="assets-text">
            <h3 className="assets-heading">Asset Portfolio</h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AssetsEn;
